import PropTypes from 'prop-types';
import React from 'react'

import { Onboarding } from '~/components'


export default class extends React.Component {
    static propTypes = {
		profile: PropTypes.object.isRequired,
		session: PropTypes.object.isRequired,
	};

    state = {
        started: false,
        completed: true
    };

    page = 'profile';

    checkProps = (prevProps, nextProps) => {
		return  !!prevProps &&
				!('user_id' in this.props.match.params) &&
				'onboarding' in nextProps.session.user && 
				!nextProps.profile.fetching &&
				!prevProps.profile.fetching;
	};

    componentDidMount(prevProps) {
		if( !this.checkProps(prevProps, this.props) ) return;
		this.setState({
			started: true,
			completed: !!this.props.session.user.onboarding[this.page]
		})
	}

    componentDidUpdate(prevProps) {
		this.setState({
			started: true,
			completed: !!this.props.session.user.onboarding[this.page]
		})
	}

    shouldComponentUpdate(nextProps, nextState) {
		if( this.state.started ) return false;
		if( this.state.completed !== nextState.completed ) return true;
		if( this.checkProps(this.props, nextProps) ) return true;
		return false;
	}

    render() {
		return !this.state.completed && <Onboarding page={this.page} />
	}
}


// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Onboarding.jsx